import { mapMarket } from "../../config/mapMarket";
import { routesConfig } from "../../config/routes";
import { WizardStep, WizardStepIndex } from "../enums/WizardStep";

interface NavigationLinks {
  nextLink: string;
  previousLink: string;
}

const navigationLinks = (
  activeStepIndex: WizardStepIndex,
  market: string
): NavigationLinks => {
  if (!market) {
    return {
      nextLink: activeStepIndex === WizardStepIndex.Market ? "/" : "",
      previousLink: "",
    };
  }

  let routeMarket = market === "sv-SE" ? "sv" : market;
  
  if(window.location.href.toLocaleLowerCase().includes("fr-ca")) 
  {
      routeMarket = "fr-CA";
  }
    
  if(window.location.href.toLocaleLowerCase().includes("fr-be")) 
    {
        routeMarket = "fr-BE";
    }
    
    if(window.location.href.toLocaleLowerCase().includes("nl-be")) 
      {
          routeMarket = "nl-BE";
      }
      
  if(market.toLocaleLowerCase().includes("en-ca")) 
  {
      routeMarket = "en-US";
  }
    
  if(market.toLocaleLowerCase().includes("en-nz")) 
  {
      routeMarket = "en-AU";
  }

  if (mapMarket[routeMarket]) {
    return { 
      previousLink: undefined,
      nextLink: undefined 
    };
  }

  if (activeStepIndex === WizardStepIndex.Market) {
    return {
      previousLink: undefined,
      nextLink: routesConfig[routeMarket].machineTonnageStep,
    };
  }

  if (activeStepIndex === WizardStepIndex.MachineTonnage) {
    return {
      previousLink: routesConfig[routeMarket].marketStep,
      nextLink: routesConfig[routeMarket].productStep,
    };
  }

  if (activeStepIndex === WizardStepIndex.Product) {
    return {
      previousLink: routesConfig[routeMarket].machineTonnageStep,
      nextLink: routesConfig[routeMarket].otherOptionsStep,
    };
  }

  if (activeStepIndex === WizardStepIndex.Optional) {
    return {
      previousLink: routesConfig[routeMarket].productStep,
      nextLink: routesConfig[routeMarket].contactUsStep,
    };
  }

  if (activeStepIndex === WizardStepIndex.ContactUs) {
    return {
      previousLink: routesConfig[routeMarket].otherOptionsStep,
      nextLink: undefined,
    };
  }

  return undefined;
};

const link = (wizardStep: WizardStep, market: string): string => {
  if (!market || !wizardStep) {
    return "";
  }
  let routeMarket = market === "sv-SE" ? "sv" : market;

  if(window.location.href.includes("fr-ca")) 
  {
      routeMarket = "fr-CA";
  }

  if(window.location.href.includes("fr-be")) 
    {
        routeMarket = "fr-BE";
    }
    
  if (wizardStep === WizardStep.Market) {
    return routesConfig[routeMarket].marketStep;
  }

  if (wizardStep === WizardStep.MachineTonnage) {
    return routesConfig[routeMarket].machineTonnageStep;
  }

  if (wizardStep === WizardStep.Product) {
    return routesConfig[routeMarket].productStep;
  }

  if (wizardStep === WizardStep.Optional) {
    return routesConfig[routeMarket].otherOptionsStep;
  }

  if (wizardStep === WizardStep.ContactUs) {
    return routesConfig[routeMarket].contactUsStep;
  }

  return undefined;
};

export const linkHelper = {
  navigationLinks,
  link,
};
